import React, { Fragment } from 'react';
import T from 'prop-types';

import MainSideLayout from '../../_shared/components/MainSideLayout';
import ChartCaptions from '../../_shared/components/ChartCaptions';
import ChartLegend from '../../_render-chart/components/ChartLegend';
import Container from '../../../../components/Container';
import { splitHtml } from '../utils';

const AppSummary = ({
  data,
  isMobileView,
}) => {
  const captions = [{
    header: 'Region & Time Period',
    desc: `Worldwide <br> ${data.time_period}`,
  }, {
    header: data.metric_header_trend,
    desc: data.metric_subheader_trend,
  }, {
    header: 'Correlation',
    desc: data.correlation_text,
  }, {
    header: 'Notes',
    desc: data.notes,
  }];

  return (
    <div className="app-summary">
      <MainSideLayout
        title={(
          <Fragment>
            <h1 className="app-summary__title">{data.header}</h1>
            {!isMobileView && (
              <div className="app-summary__date">
                Updated {data.published_date}
              </div>
            )}
          </Fragment>
        )}
        mainContent={(
          <div className="chart-image-legend-box">
            <img
              src={data[isMobileView ? 'chart_image_url_mobile' : 'chart_image_url']}
              alt={data.header}
            />
            <ChartLegend options={data.chart_legend} />
          </div>
        )}
        sideContent={(
          <ChartCaptions data={captions} />
        )}
        className="app-chart-wrapper"
      />

      <Container maxWidth={1248}>
        <h2 className="app-summary__subtitle">{data.subheader}</h2>
        <div className="app-summary__description">
          {splitHtml(data.subheader_section).map((item, index) => (
            <div
              key={index}
              className="app-summary__description-inner"
              dangerouslySetInnerHTML={{ __html: item }}
            />
          ))}
        </div>
      </Container>
    </div>
  );
};

AppSummary.propTypes = {
  data: T.shape({
    header: T.string,
    published_date: T.string,
    time_period: T.string,
    notes: T.string,
    correlation_text: T.string,
    metric_header_trend: T.string,
    metric_subheader_trend: T.string,
    chart_image_url: T.string,
    chart_image_url_mobile: T.string,
    chart_legend: T.array,
    subheader: T.string,
    subheader_section: T.string,
  }).isRequired,
  isMobileView: T.bool.isRequired,
};

export default AppSummary;
